import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Empty, Alert } from 'antd';
import './style.scss';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import BusyConnectionList from '../BusyConnectionList';
import BusyIntegrationActions from '../../../../../actions/integrations/busyIntegrationAction';

/**
 *
 */
function BusyHome({
  user, getBusyConnectionsLoading, history, getBusyConnections, busyConnections,
}) {
  const [isUserAllReadyConnected, setIsUserAllReadyConnected] = React.useState(false);

  useEffect(() => {
    getBusyConnections(user?.tenant_info?.org_id);
  }, []);

  useEffect(() => {
    if (busyConnections?.filter((item) => item)?.length > 0) {
      setIsUserAllReadyConnected(true);
    } else {
      setIsUserAllReadyConnected(false);
    }
  }, [busyConnections]);

  return (
    <div className="busy-integration-wrapper">

      <div
        style={
          {
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            marginBottom: '-15px',
          }
        }
      >
        <div className="busy-integration__heading">Busy Integration </div>
        <div>
          <H3Button
            text="+ New Connections"
            buttonType={defaultButtonTypes.BLUE_ROUNDED}
            onClick={() => {
              const id = 'new Account';
              history.push('/admin/integration/busy/setup?is_create_flow=true', { id });
            }}
            customClass="busy__location-submit"
            isLoading={getBusyConnectionsLoading}
            disabled={getBusyConnectionsLoading}
          />
        </div>
      </div>

      { !getBusyConnectionsLoading ? (
        <React.Fragment>
          {isUserAllReadyConnected === true && (
            <React.Fragment>
              {/* <div className="busy-list-wrapper">
                <Alert
                  message="Please select the organisation to be connected with procuzy account. Organisation selection is a one time process and cannot be changed once confirmed."
                  type="warning"
                  showIcon
                />
              </div> */}
              <BusyConnectionList callback={() => setIsUserAllReadyConnected(false)} />
            </React.Fragment>

          )}
          {isUserAllReadyConnected === false
            && (
              <React.Fragment>
                <div className="no-busy-found__wrapper">
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description=""
                  />
                  <p className="no-busy-found__heading">Your Procuzy account is not yet connected to Busy</p>
                </div>
              </React.Fragment>
            )}

        </React.Fragment>
      ) : (
        <div className="busy-list-wrapper">
          {

            [1, 2, 3].map((item) => (
              <div
                key={item}
                className="loading-busy__card"
              >
                <div className="busy-card-spacing">

                  <div className="busy-card-header ">

                    <div className="loadingBlock loading-busy-header__text" />
                    <div className="loadingBlock loading-busy-header__image"> </div>
                  </div>

                  <div className="loadingBlock loading-busy-card__link"> </div>
                  <div className="busy-card-footer">
                    <div
                      className="flex "
                    >
                      <p className="loadingBlock loading-busy-card__footer" />
                    </div>
                  </div>
                </div>
              </div>

            ))

          }

        </div>
      ) }
    </div>
  );
}

const mapStateToProps = ({ UserReducers, BusyIntegrationReducers }) => ({
  getBusyConnectionsLoading: BusyIntegrationReducers.getBusyConnectionsLoading,
  user: UserReducers.user,
  busyConnections: BusyIntegrationReducers.busyConnections,
});
const mapDispatchToProps = (dispatch) => ({
  getBusyConnections: (orgId, callback) => dispatch(BusyIntegrationActions.getBusyConnections(orgId, callback)),

});
BusyHome.propTypes = {
  user: PropTypes.any,
  history: PropTypes.any,
  getBusyConnectionsLoading: PropTypes.bool,
  getBusyConnections: PropTypes.func,
  busyConnections: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BusyHome));
